import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflowY: 'auto',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    margin: theme.spacing(4),
  },
  tituloEspelho: {
    fontSize: '16px',
  },
  corpoEspelho: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
  divider: {
    marginTop: theme.spacing(1),
  },
  botaoVoltar: {
    marginTop: theme.spacing(2),
    backgroundColor: '#9E1A1A',
    color: 'white',
    '&:hover': {
      backgroundColor: '#9E1A1A',
    },
  },
}))

export default useStyles
